
<div class="container-fluid ">
  <top-bar />


  <div class="row pt-5" [ngClass]="{ 'hide': message==null, 'show': message!= null }" style="">
    <div class="col-10 col-md-8 col-lg-6 offset-lg-3 offset-md-2 offset-1">
      <a *ngIf="message" href="javascript:void(0);" (click)="clearMessage();" class="btn btn-primary" style="position: relative; z-index: 1000 !important; float: right;"><i class="pi pi-times"></i></a>
      <div *ngIf="message" [ngClass]="{ 'alert': message, 'alert-success': message.type === 'success', 'alert-danger': message.type === 'error', 'alert-info': message.type === 'info' }">{{message.text}}</div>
    </div>
  </div>

  <router-outlet (activate)="activated($event)"></router-outlet>
</div>

<p-toast position="top-left" key="tl"></p-toast>
<p-toast position="top-center" key="tc"></p-toast>
<p-toast position="bottom-center" key="bc"></p-toast>

<p-confirmDialog >
  <ng-template pTemplate="footer" let-message>
          <button type="button" pButton (click)="onConfirm()" label="Yes" class="btn btn-primary me-2"></button>
          <button type="button" pButton (click)="onReject()" label="No" class="btn btn-secondary"></button>
  </ng-template>
</p-confirmDialog>


